import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { PageTitle } from "../../../../components/ui-kit";
import api from "../../../../util/api";
import CustomerDetails from "../components/Details";
import { isNotFoundApiError } from "../../../../util/apiErrorMessage";
import PageNotFound from "../../../../components/page-not-found";
import { CustomerApiType } from "../../../../util/types";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CustomerInfo: React.FunctionComponent = () => {
  const { customerId } = useParams<{ customerId: string }>();
  const [customerDetails, setCustomerDetails] = useState<CustomerApiType>();
  const [notFound, setNotFound] = useState(false);
  const [fatalError, setFatalError] = useState<unknown>(null);
  const navigate = useNavigate();

  useEffect(() => {
    getCustomer(customerId!);
  }, [customerId]);

  const getCustomer = async (customerId: string) => {
    setNotFound(false);
    setFatalError(null);
    try {
      const result = await api.getCustomerById(customerId);
      setCustomerDetails(result);
    } catch (e: unknown) {
      if (isNotFoundApiError(e)) {
        setNotFound(true);
        return;
      }
      setFatalError(e);
    }
  };

  if (fatalError) {
    throw fatalError;
  }

  if (notFound) {
    return <PageNotFound />;
  }

  return customerDetails ? (
    <AnimateAppearanceWrapper>
      <Container>
        <TopLine>
          <PageTitle
            onBack={() => {
              navigate(-1);
            }}
            title={`Customer ${customerDetails.name ?? ""}`}
          />
        </TopLine>
        <CustomerDetails data={customerDetails} />
      </Container>
    </AnimateAppearanceWrapper>
  ) : (
    <></>
  );
};
